import {createEntityAdapter, createSlice} from "@reduxjs/toolkit";

function findIndexByTemplateId(templates, id) {
    for (let i=0; i<templates.length; i++) {
        if (templates[i].reportId == id) return i
    }
}

export const OUTPUT_FORMS_SLICE = 'outputForms';

const outputFormsAdapter = createEntityAdapter();
const outputFormsSlice = createSlice({
    name: OUTPUT_FORMS_SLICE,
    initialState: outputFormsAdapter.getInitialState({
        templates: [],
    }),
    reducers: {
        initTemplates: (state, payload) => {
            const reqTemplates = payload.payload
            state.templates = []
            Object.assign(state.templates, reqTemplates);
        },
        removeTemplate: (state, payload) => {
            const id = payload.payload
            const index = findIndexByTemplateId(state.templates, id)

            console.log("INSIDE REMOVE: " + id)
            console.log("INSIDE REMOVE(INDEX): " + index)

            state.templates.splice(index, 1)
        }
    },
    extraReducers: {

    },
});

export default outputFormsSlice.reducer;

export const {
    initTemplates,
    removeTemplate
} = outputFormsSlice.actions;